import React from 'react';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { Login } from '../components/Login/Login';

import { Curriculum } from '../components/Curriculum/Curriculum';

const Rutas = () => {
  return (
    <Router
      basename={
        process.env.NODE_ENV === 'development' ? '/' : '/curriculumvitae'
      }
    >
      <Routes>
        {/* <Route exact path="/" element={<Curriculum />} /> */}
        <Route exact path="/" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default Rutas;
